/* Delfino — kitul „advm” (advertorial Matrix 4, șold la menopauză; 06.10.2026). Un singur script mic
   pentru cele două lucruri care au nevoie de JS:

   1. Clipul din blocul 2 (`[data-advm-player]`): posterul cu „APASĂ PENTRU SUNET”; la apăsare, clipul
      pornește de la început, CU sunet și cu comenzile native (exact ca pe pagina de referință).

   2. Cardurile ofertei (`[data-advm-offers] .advm-pk[data-advm-qty]`): la apăsare pe card (sau pe butonul
      Releasit din el) scriem cantitatea cardului în formularul de produs (`form.shopify-product-form
      [name="quantity"]`), de unde aplicația Releasit o citește când deschide pop-up-ul, și emitem
      `dl:bundle-changed` pe document — evenimentul pe care îl ascultă sincronizarea din product.js
      (bindOfferSync bifează aceeași ofertă în pop-up și o ține bifată). Nu atingem formularul Releasit.
      Ascultătorul e pe document, în faza de captură: rulează ÎNAINTE ca butonul Releasit (care
      înlocuiește ancora `/rsi-btn-hook` din card) să deschidă pop-up-ul.
   Idempotent (data-bound), ca restul scripturilor de secțiune (DL.use). */
(function () {
  'use strict';

  function toInt(v, d) {
    var n = parseInt(v, 10);
    return isNaN(n) ? d : n;
  }

  /* ---------- 1. clipul ---------- */
  function bindPlayers(root) {
    var players = (root || document).querySelectorAll('[data-advm-player]:not([data-bound])');
    for (var i = 0; i < players.length; i++) {
      (function (box) {
        box.dataset.bound = '1';
        var video = box.querySelector('video');
        var click = box.querySelector('[data-advm-play]');
        if (!video || !click) return;
        click.addEventListener('click', function () {
          box.classList.add('is-playing');
          video.muted = false;
          video.controls = true;
          try { video.currentTime = 0; } catch (e) { /* metadata încă neîncărcată — pornește oricum de la 0 */ }
          var p = video.play();
          if (p && p.catch) p.catch(function () { /* browserul a refuzat redarea — rămân comenzile native */ });
        });
      })(players[i]);
    }
  }

  /* ---------- 2. cardurile ofertei ---------- */
  function choose(box, card) {
    var qty = toInt(card.getAttribute('data-advm-qty'), 1);
    var cards = box.querySelectorAll('.advm-pk');
    for (var i = 0; i < cards.length; i++) {
      var on = cards[i] === card;
      cards[i].classList.toggle('is-active', on);
      cards[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    var inputs = document.querySelectorAll('form.shopify-product-form input[name="quantity"]');
    for (var j = 0; j < inputs.length; j++) inputs[j].value = String(qty);
    var total = toInt(card.getAttribute('data-advm-total'), 0);
    var was = toInt(card.getAttribute('data-advm-was'), 0);
    try {
      document.dispatchEvent(new CustomEvent('dl:bundle-changed', {
        detail: { qty: qty, total: total, was: was > total ? was : null, perUnit: toInt(card.getAttribute('data-advm-perunit'), 0) }
      }));
    } catch (e) { /* browser fără CustomEvent — cantitatea e oricum în formular */ }
  }

  function bindOffers(root) {
    var boxes = (root || document).querySelectorAll('[data-advm-offers]:not([data-bound])');
    for (var i = 0; i < boxes.length; i++) boxes[i].dataset.bound = '1';
    if (!boxes.length || document.documentElement.dataset.advmOffers) return;
    document.documentElement.dataset.advmOffers = '1';
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var card = t.closest('[data-advm-offers] .advm-pk[data-advm-qty]');
      if (card) choose(card.closest('[data-advm-offers]'), card);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target && e.target.closest ? e.target.closest('[data-advm-offers] .advm-pk[data-advm-qty]') : null;
      if (card && e.target === card) { e.preventDefault(); choose(card.closest('[data-advm-offers]'), card); }
    });
  }

  /* ---------- 3. cifrele animate (advm-stats) ---------- */
  function fmt(n, decimals) {
    var fixed = n.toFixed(decimals).split('.');
    var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decimals > 0 ? whole + ',' + fixed[1] : whole;
  }

  function bindStats(root) {
    var grids = (root || document).querySelectorAll('[data-advm-stats]:not([data-bound])');
    var reduce = false;
    try { reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { reduce = false; }
    for (var g = 0; g < grids.length; g++) {
      (function (grid) {
        grid.dataset.bound = '1';
        var stats = grid.querySelectorAll('[data-advm-stat]');
        /* cifra afișată se scrie românește (3.000 · 4,9), și fără animație */
        for (var f = 0; f < stats.length; f++) {
          var v = stats[f].querySelector('[data-advm-val]');
          var num = parseFloat(stats[f].getAttribute('data-advm-to'));
          if (v && !isNaN(num)) v.textContent = fmt(num, toInt(stats[f].getAttribute('data-advm-decimals'), 0));
        }
        if (reduce || typeof window.IntersectionObserver !== 'function') return; /* rămâne starea finală */
        for (var i = 0; i < stats.length; i++) stats[i].classList.add('is-waiting');
        function play(stat) {
          stat.classList.remove('is-waiting');
          var el = stat.querySelector('[data-advm-val]');
          var to = parseFloat(stat.getAttribute('data-advm-to'));
          var decimals = toInt(stat.getAttribute('data-advm-decimals'), 0);
          if (!el || isNaN(to)) return;
          var finalText = el.textContent;
          var start = null;
          var dur = 1500;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = p < 1 ? fmt(to * eased, decimals) : finalText;
            if (p < 1) window.requestAnimationFrame(step);
          }
          window.requestAnimationFrame(step);
        }
        var io = new window.IntersectionObserver(function (entries) {
          for (var k = 0; k < entries.length; k++) {
            if (!entries[k].isIntersecting) continue;
            play(entries[k].target);
            io.unobserve(entries[k].target);
          }
        }, { threshold: 0.35 });
        for (var n = 0; n < stats.length; n++) io.observe(stats[n]);
      })(grids[g]);
    }
  }

  function bind(root) {
    bindPlayers(root);
    bindOffers(root);
    bindStats(root);
  }

  function register() {
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(bind);
    else bind(document);
  }
  if (window.DL && typeof window.DL.use === 'function') register();
  else document.addEventListener('DOMContentLoaded', register);
})();
